import { StringParam, UrlUpdateType, useQueryParam } from 'use-query-params';

export const STATUS_QUERY_KEY = 'status';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseStatusReturn = {
	status: string | null | undefined;
	setStatus: (newValue: NewValueType<string | undefined | null>, updateType?: UrlUpdateType | undefined) => void;
};

export const useStatus = (): UseStatusReturn => {
	const [status, setStatus] = useQueryParam(STATUS_QUERY_KEY, StringParam);

	return {
		status: status as string,
		setStatus
	};
};
